import { createContext, useContext } from 'react';

export interface FaqsImportContext {
  mode: 'page' | 'modal';
  goHome: () => void;
}

// eslint-disable-next-line @typescript-eslint/no-empty-function
export const FaqsImportContext = createContext<FaqsImportContext>({ mode: 'page', goHome: () => {} });

export const useFaqsImportMode = () => {
  const { mode } = useContext(FaqsImportContext);
  return mode;
};

export const useFaqsImportHome = () => {
  const { goHome } = useContext(FaqsImportContext);
  return goHome;
};
